export default __webpack_public_path__ + "static/media/qh.00b3c83d.svg";